import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { MdOutlineSimCardDownload } from "react-icons/md";
import InputBox from "Components/InputBox";

// Styles
import "./styles.scss";

//Redux
import { useDispatch, useSelector } from "react-redux";
import { getReportsListRequest_ADMIN } from "../../../../Redux/Slices/Admin/adminSlice";

// Custom layout
import MainLayout from "Layouts/Main";

// Assets
import Colors from "../../../../Assets/SassConstants/colors.scss";

// Custom component
import NormalTable from "Components/NormalTable";
import moment from "moment";
import { getPdfData, getReportDetailspdfData, multiUpload, updatePdfURL } from "../../../../Redux/Slices/User/userSlice";
import { notifySuccess } from "Services/Utils/toastNotification";
import Loader from "Components/Loader";
import { ReportDownload } from "Components/ReportDownload";

const Reports = () => {
  //Initialize redux
  const dispatch = useDispatch();

  //==================== List screen start ====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [reportsList, setReportsList] = useState([]);
  const [activeRow, setActiveRow] = useState(null);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({
    sortBy: null,
    sortOrder: 0,
  });
  const [isShowDownload, setIsShowDownload] = useState(false)
  const downloadRef = useRef()
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.admin.isLoading);
  const [isLoader, setIsLoader] = useState(false)
  const [pdfReport, setPdfReport] = useState(null)
  const [scores, setScores] = useState(null)
  const { reportId } = useSelector((state) => state.report);

  const reportsHeader = [
    { label: "S.No", isSort: false, key: "sno" },
    { label: "Company Name", isSort: true, key: "company_name" },
    { label: "Reference Number", isSort: true, key: "reference_name", headerStyle: { paddingInline: "15px" } },
    { label: "Assessor Name", isSort: true, key: "assessor_name" },
    { label: "Assessment Start Date", isSort: false, key: "assessment_sent" },
    { label: "Submitted Date", isSort: false, key: "report_received" },
    { label: "Actions", isSort: false, key: "action", headerStyle: { marginInline: "auto" } },
  ];

  const handlePageChange = async (page) => {
    await setCurrentPage(page);
    await getReportsListRequest_ADMIN_(page);
  };

  const handleMenuToggle = (rowIndex) => {
    setActiveRow(activeRow === rowIndex ? null : rowIndex);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setActiveRow(null);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  useEffect(() => {
    getReportsListRequest_ADMIN_(currentPage);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sort, search]);

  //To handle the index
  const getDisplayedIndex = (currentPage, index) => {
    // Calculate the starting index for the current page
    const startingIndex = (currentPage - 1) * 8 + 1;
    return startingIndex + index;
  };

  const handleViewDetails = (index) => {
    navigate(`/reports/report-details/${index}`);
  };

  // const handleDownloadPDF = async (backlog_id) => {
  //   dispatch(
  //     getReportDetailspdfData({
  //       assessmentId: backlog_id,
  //       callBack: (data) => {
  //         if (data.data.data) {
  //           window.open(data.data.data, "_blank", "noreferrer");
  //         } else {
  //           notifySuccess(data.data.message)
  //         }
  //       }
  //     })
  //   )
  // }

  const handleDownloadPDF = async (backlogId) => {
    setIsShowDownload(true);
    try {
      await dispatch(
        getReportDetailspdfData({
          assessmentId: backlogId,
          callBack: (data) => {
            const existingUrl = data?.data?.data?.url || data?.data?.data;

            if (existingUrl && typeof existingUrl === "string" && existingUrl.startsWith("http")) {
              window.open(existingUrl, "_blank", "noreferrer");
              setIsShowDownload(false);
            } else {
              dispatch(
                getPdfData({
                  reportId: backlogId,
                  callBack: (pdfData) => {
                    if (pdfData) {
                      getScores(pdfData);
                      setPdfReport({ ...pdfData, currentBacklogId: backlogId });
                    } else {
                      console.error("No PDF data available.");
                      setIsShowDownload(false);
                    }
                  },
                })
              );
            }
          },
        })
      );
    } catch (error) {
      console.error("Error fetching PDF data:", error);
      setIsShowDownload(false);
    }
  };

  const getScores = (data) => {
    const scoreMap = {}
    data?.result?.map((item) => {
      item?.performance_results?.map((it) => {
        scoreMap[it?.category_name] = it?.average_score
      })
    })
    setScores(scoreMap)
  }

  // Trigger download via the ref
  const triggerDownload = () => {
    setIsShowDownload(true);
    setIsLoader(true)
    const currentReport = pdfReport;

    setTimeout(async () => {
      try {
        if (downloadRef.current) {
          const pdfBlob = await downloadRef.current.download();

          if (pdfBlob) {
            const formData = new FormData();
            const pdfFile = new File([pdfBlob], `Report_${pdfReport.backlog_id}.pdf`, { type: "application/pdf" });
            formData.append("files", pdfFile);

            await dispatch(
              multiUpload({
                files: formData,
                callBack: async (uploadedFiles) => {
                  const uploadedUrl = uploadedFiles?.[0]?.url;

                  if (uploadedUrl) {
                    await dispatch(
                      updatePdfURL({
                        reportId: currentReport.currentBacklogId,
                        url: uploadedUrl,
                      })
                    );
                  }
                },
              })
            );
          }
          setPdfReport(null);
        } else {
          console.error("Download ref not ready");
        }
      } catch (err) {
        console.error("Download failed", err);
      } finally {
        setIsShowDownload(false);
        setIsLoader(false)
      }
    }, 100);
  };

  useEffect(() => {
    if (pdfReport) {
      triggerDownload();
    }
  }, [pdfReport]);


  //To call getReportsListRequest_ADMIN
  const getReportsListRequest_ADMIN_ = (page) => {
    dispatch(
      getReportsListRequest_ADMIN({
        page: page,
        search,
        sortBy: sort.sortOrder === 1 ? "ASC" : "DESC",
        orderBy: sort.sortBy,
        limit: 8,
        callBack: getReportsListRequestCB_ADMIN,
      })
    );
  };

  //To handle the response of getReportsListRequest_ADMIN
  const getReportsListRequestCB_ADMIN = (data) => {
    setTotalPages(data?.pageMeta?.totalPages);
    setReportsList(data?.data_list);
  };
  //==================== List screen end ====================

  return (
    <MainLayout style={{ backgroundColor: Colors.grey_12 }}>
      {isLoader ? (
        <div className="loader-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', flexDirection: "column" }}>
          <Loader />
          <div style={{ marginTop: "10px" }}>
            Do not go back or refresh the page while the report is downloading. Please wait.
          </div>
        </div>

      ) : (
        <div className="admin-reports-admin-container">
          {/* Heading and Button Section */}

          <div className="">
            <div className="d-flex justify-content-between align-items-center">
              <label className="assessmentSubmittedTitle">Conduct Reports</label>
              <div className="me-3">
                <InputBox
                  name="search"
                  isSearch={true}
                  placeholder="Search"
                  value={search}
                  onChange={(e) => handleSearch(e)}
                  inputStyle={{ width: "277px" }}
                />
              </div>
            </div>
          </div>

          <div className="backlog-table">
            <NormalTable
              loading={isLoading === 'loading'}
              headers={reportsHeader}
              sort={sort}
              setSort={setSort}
              currentPage={currentPage}
              noDataColspan={6}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              customStyle={{
                customTableHeaderContainer: "customAdminReportTableHeader",
                customHeaderTitle: "customAdminReportHeaderStartTitle",
                customTable: "customAdminReportTable",
                customTableContainer: "customAdminReportTableContainer",
              }}
              noDataLabel={reportsList?.length === 0}
            >
              {reportsList?.map((row, index) => {
                return (
                  <tr key={index} style={{ position: "relative" }}>
                    <td>
                      <div className="TableDivisionStart ms-5 ps-2 mt-2">
                        {getDisplayedIndex(currentPage, index)}
                      </div>
                    </td>
                    <td>
                      <div className="TableDivisionStart ms-2 mt-2">
                        {row.company_name ?? "-"}
                      </div>
                    </td>
                    <td>
                      <div className="TableDivisionStart ms-2 mt-1" style={{ paddingInline: "15px" }}>
                        {row.reference_name ?? "-"}
                      </div>
                    </td>
                    <td>
                      <div className="TableDivisionStart ms-2 mt-2">
                        {row.assessor_name ?? "-"}
                      </div>
                    </td>
                    <td>
                      <div className="TableDivisionStart ms-2 mt-2">
                        {!!row.createdAt
                          ? moment(row.createdAt).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                    </td>
                    <td>
                      <div className="TableDivisionStart ms-2 mt-2">
                        {!!row.submitted_on
                          ? moment(row.submitted_on).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                    </td>

                    <td>
                      <div
                        onClick={() => handleMenuToggle(index)}
                        className="TableDivisionStart"
                      >
                        <div className="d-flex flex-row justify-content-center align-items-center gap-3" style={{ marginTop: "6px" }}>
                          {/* <button
                        type="button"
                        className="reports-admin-form-save-button"
                        onClick={() => handleViewDetails(row.backlog_id)}
                      >
                        ViewDetails
                      </button> */}
                          <FaRegEye
                            onClick={() => handleViewDetails(row.backlog_id)}
                            size={25}
                            color={Colors.grey_17}
                            style={{ cursor: "pointer" }}
                          />

                          <MdOutlineSimCardDownload
                            onClick={() => handleDownloadPDF(row.backlog_id)}
                            size={25}
                            color={Colors.grey_17}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </NormalTable>
          </div>
        </div>
      )}
      {
        isShowDownload &&
        <ReportDownload ref={downloadRef} resultData={pdfReport} scores={scores} />
      }
    </MainLayout>
  );
};

export default Reports;
